import "../sellscreendialogs.scss";
import {
    type FC,
    useCallback,
    useEffect,
    useState,
} from "react";
import { DateTimeInput } from "@onshopfront/components";
import moment from "moment";
import { useShopfrontDispatch } from "#/_Bootstrap/hooks.ts";
import { hideDialog } from "#/Actions/Dialogs/DialogActions.ts";
import {
    addGiftCardToSale,
    type SaleAddGiftCardOptions,
} from "#/Actions/SellScreen/SellScreenProductActions.tsx";
import { formatDate } from "#/Utilities/Generic/Strings.ts";
import { getOption } from "#/Utilities/Platform/Options/Options.ts";
import { getPolicy } from "#/Utilities/Platform/Policies/Policies.ts";
import Button from "../../../../Common/Buttons/Button";
import PopupManager from "../../../../Common/Popups/PopupManager";

export const RequestExpiry: FC<SaleAddGiftCardOptions> = (options) => {
    const editable = getOption("outlet_gift_card_expiry_change");
    const dispatch = useShopfrontDispatch();
    const [ value, setValue ] = useState(() => {
        let expiryAmount = getOption("outlet_gift_card_expiry_amount");

        if(isNaN(expiryAmount)) {
            expiryAmount = 1;
        }

        return moment().add(
            expiryAmount < 1 ? 1 : expiryAmount,
            getOption("outlet_gift_card_expiry_period")
        );
    });

    useEffect(() => {
        if(options.source !== "auto" && options.source !== "internal") {
            const sources = getPolicy("gift_card_sources", []);

            for(let i = 0, l = sources.length; i < l; i++) {
                if(sources[i].connection === options.source) {
                    setValue(moment().add(sources[i].expiry, "years"));

                    return;
                }
            }

            throw new Error("Unable to find gift card source address");
        }
    }, [ options.source ]);

    const addExpiry = useCallback(() => {
        if(value.isBefore(moment())) {
            PopupManager.error("Invalid expiry entered, please enter a valid date and try again");

            return;
        }

        dispatch(hideDialog());
        dispatch(addGiftCardToSale({
            ...options,
            expiry: value.toISOString(true),
        }));
    }, [ dispatch, options, value ]);

    if(editable) {
        return (
            <div className="request-expiry">
                <p>Please enter the gift card&apos;s expiration date</p>
                <DateTimeInput
                    value={[ value?.toDate() ?? null ]}
                    onChange={([ date ]) => setValue(moment(date))}
                    placeholder="Expiry..."
                />
                <div className="buttons">
                    <Button
                        type="button"
                        classes={[ "button-cancel" ]}
                        onClick={() => dispatch(hideDialog())}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        classes={[ "button-save" ]}
                        onClick={addExpiry}
                    >
                        Add
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className="request-expiry">
            <p>The gift card&apos;s expiration date is</p>
            <span className="expiry">{formatDate(value)}</span>
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "button-save" ]}
                    onClick={addExpiry}
                    autoFocus
                >
                    OK
                </Button>
            </div>
        </div>
    );
};
